module.exports = __webpack_public_path__ + "img/zanhuanfafang.ae306795.svg";